/* eslint-disable */

import Cookies from 'js-cookie'
import CallApp from '@/components/callapp'
import { articles } from '@/api/api'
import wx from 'weixin-js-sdk'

export default {
  /* 是否是名厨浏览器*/
  isGteatChefbrowser() {
    const str = 'GREATCHEF'
    const userAgent = navigator.userAgent.toUpperCase()
    console.log('浏览器信息', userAgent)
    if (userAgent.indexOf(str) >= 0) {
      return true
    } else {
      return false
    }
  },
  isiOS() { // 苹果浏览器
    const u = navigator.userAgent
    return !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/)
  },
  isAndroid() { // 安卓浏览器
    const u = navigator.userAgent
    return u.indexOf('Android') > -1 || u.indexOf('Adr') > -1
  },
  is_weixn() {
    var ua = navigator.userAgent.toLowerCase()
    if (ua.match(/MicroMessenger/i) == 'micromessenger') {
      return true
    } else {
      return false
    }
  },
  is_mini() { // 之后判断时候为小程序用这个
    let isMini = false
    wx.miniProgram.getEnv((res) => {
      isMini = res.miniprogram
    })
    return isMini
  },
  isMini() { // 是否是微信小程序 仅用于大事件活动
    return new Promise((resolve, reject) => {
      wx.miniProgram.getEnv((res) => {
        if (res.miniprogram) {
          resolve(true)
        } else {
          reject(false)
        }
      })
    })
  },
  goMiniPage($url) { // 跳转到小程序，小程序嵌套的webview
    wx.miniProgram.navigateTo({ url: `/${$url}` }) // 为了和app路径统一
  },
  goAppPage($param = {}, callback) { // 跳转到app
    return new Promise((resolve, reject) => {
      dsBridge.call('jsPushNativeVc', $param, function(result) {
        resolve(result)
      })
    })
  },
  goWxMiniProgram($path) { // 打开微信小程序，通过app
    dsBridge.call('openWxMiniProgram', { mini_id: 'gh_8b2e6fe33be7', mini_path: $path })
  },
  getAuth() { // 获取用户信息
    return new Promise((resolve, reject) => {
      dsBridge.call('getAuth', function(result) {
        resolve(result)
      })
    })
  },
  praise() {
    return new Promise((resolve, reject) => {
      dsBridge.register('praiseCallBack', function(uid, head_pic) {
        resolve(uid, head_pic)
      })
    })
  },
  delComment(data) {
    return new Promise((resolve, reject) => {
      dsBridge.call('delComment', data, function(result) {
        resolve(result)
      })
    })
  },
  alertBox(data) {
    dsBridge.call('alertBox', data)
  },
  login() {
    return new Promise((resolve, reject) => {
      dsBridge.call('login', function(result) {
        resolve(result)
      })
    })
  },
  commentCallBack() {
    return new Promise((resolve, reject) => {
      dsBridge.register('commentCallBack', function(comment_id, comment) {
        const res = {
          comment_id: comment_id,
          comment: comment
        }
        resolve(res)
      })
    })
  },
  comment(data) {
    return new Promise((resolve, reject) => {
      dsBridge.call('comment', data, function(result) {
        resolve(result)
      })
    })
  },
  getEnv() { // 获取app环境
    return new Promise((resolve, reject) => {
      dsBridge.call('env', function(result) {
        resolve(result)
      })
    })
  },
  isLogin() { // 是否登陆
    return new Promise((resolve, reject) => {
      dsBridge.call('isLogin', function(result) {
        resolve(result)
      })
    })
  },
  showShare() {
    dsBridge.call('CallLocalShare')
  },
  publishFoodClick(des, id, title) { // 拉起app某个页面
    return new Promise((resolve, reject) => {
      dsBridge.call('pulishFoodClick', `{"des":"${des}","skuid":"${id}","keyword":"${title}"}`, function(result) {
        resolve(result)
      })
    })
  },
  miniShare($data = {}) { // 小程序分享方法
    return wx.miniProgram.postMessage({ data: $data })
  },
  async wechatShare($data = {}) { // 微信分享接口，res-接口数据，data-需要分享携带的参数
    const config = await articles.share(escape(window.location.href)) // 获取分享的参数密钥
    const $debug = false // 关闭调试

    wx.config({ ...config, ...{ debug: $debug }})
    wx.ready(() => {
      wx.updateAppMessageShareData({ // 分享给朋友
        title: $data.share_title, // 分享标题
        desc: $data.share_desc, // 分享描述
        link: $data.share_link, // 分享链接
        imgUrl: $data.share_img, // 分享图标
        success: function() {
          // 设置成功
        }
      })
      wx.updateTimelineShareData({ // 分享朋友圈
        title: $data.share_title, // 分享标题
        link: $data.share_link, // 分享链接
        imgUrl: $data.share_img, // 分享图标
        success: function() {
          // 设置成功
        }
      })
    })
  },
  shareLink( // 之前2019榜单的分享方法，可弃用
    $res = {},
    $data = {
      shareImg: 'https://img.mingchu.co/ueditor/php/upload/image/20200119/1579429167875371.jpg'
    }
  ) { // 微信分享接口，res-接口数据，data-需要分享携带的参数
    const $debug = false // 关闭调试
    wx.config({ ...$res, ...{ debug: $debug }})
    wx.ready(() => {
      const share_title = $data.shareTitle
      const share_desc = $data.shareDesc
      const share_link = $data.shareLink
      const share_img = $data.shareImg

      wx.updateAppMessageShareData({ // 分享给朋友
        title: share_title, // 分享标题
        desc: share_desc, // 分享描述
        link: share_link, // 分享链接
        imgUrl: share_img, // 分享图标
        success: function() {
          // 设置成功
        }
      })
      wx.updateTimelineShareData({ // 分享朋友圈
        title: share_title, // 分享标题
        link: share_link, // 分享链接
        imgUrl: share_img, // 分享图标
        success: function() {
          // 设置成功
        }
      })
    })
  },
  goDown($des, $url = '', $routeId = '0') { // 新 h5跳转app
    const self = this
    const u = navigator.userAgent
    const isAndroid = u.indexOf('Android') > -1 || u.indexOf('Adr') > -1
    console.log($url, $routeId, '拉起app link')

    if (isAndroid) {
      var protocol = 'cn.com.greatchef'
      // var jumpurl = '`?params={"des":"articlesview","skuid":"'+this.$route.query.id+'"}`';
      var jumpurl = `?params={"des":"${$des}", "link":"${$url}" ,"skuid":"${$routeId}"}`
    } else {
      var protocol = 'com.greatchef.notes'
      // var jumpurl = '/articlesview?id='+this.$route.query.id;
      // this.jumpurl = '?params={"des":"articlesview","skuid":'+this.$route.query.id+'}';
      var jumpurl = `/${$des}?id=${$routeId}&link=${encodeURIComponent($url)}`
      // var jumpurl = `?params={"des":"${$des}", "link":"${$url}" ,"skuid":"${$routeId}"}`;
      // /params={“des”:“H5",“link”:“‘+url+‘“}’;
    }

    const option = {
      scheme: {
        protocol: protocol
      },
      universal: {
        host: 'oia.greatchef.com.cn',
        pathKey: ''
      },
      appstore: 'https://itunes.apple.com/app/id700641749',
      yingyongbao: 'https://a.app.qq.com/o/simple.jsp?pkgname=cn.com.greatchef',
      fallback: 'https://oia.greatchef.com.cn/',
      timeout: 2000
    }

    const lib = new CallApp(option)
    lib.open({
      path: jumpurl
    })
  },
  shareWX() {
    return new Promise((resolve, reject) => {
      dsBridge.call('shareWX', function(result) {
        resolve(result)
      })
    })
  },
  shareWXCircle() {
    return new Promise((resolve, reject) => {
      dsBridge.call('shareWXCircle', function(result) {
        resolve(result)
      })
    })
  },
  savePicToLocal() {
    return new Promise((resolve, reject) => {
      dsBridge.call('savePicToLocal', function(result) {
        resolve(result)
      })
    })
  },
  downloadImg($url) { // 下载图片
    return new Promise((resolve, reject) => {
      dsBridge.call('js_savePhotoToLocal', $url,
        function(result) {
          resolve(result)
        })
    })
  },
  deleteAndCloseWindow($param = null) { // 删除认证，然后跳到原生的列表页
    return dsBridge.call('deleteAndCloseWindow', $param)
  },
  closeWindow($param = null){ // 关闭webview
    return dsBridge.call('closeWindow', $param)
  },
  startAuthIos($Data) { // ios人脸验证
    return new Promise((resolve, reject) => {
      dsBridge.call('js_calliOSAuth', $Data,
        function(result) {
          resolve(result)
        })
    })
  },
  hideShare() { // 隐藏webview顶部分享按钮
    return new Promise((resolve, reject) => {
      dsBridge.call('hideShare', '1',
        function(result) {
          resolve(result)
        })
    })
  },
  hiddenNavi($hide = '1') {
    return new Promise((resolve, reject) => {
      dsBridge.call('js_hiddenNavigationBar', $hide, function(res) {
        resolve(res)
      })
    })
  },
  // 获取url参数
  getQueryVariable(variable) {
    var query = window.location.search.substring(1)
    var vars = query.split('&')
    for (var i = 0; i < vars.length; i++) {
      var pair = vars[i].split('=')
      if (pair[0] == variable) { return pair[1] }
    }
    return (false)
  },
  // 获取浏览器语言
  browserLanguage() {
    let lang = navigator.language || navigator.userLanguage
    lang = lang.substr(0, 2)
    if (lang == 'en') { // 英文
      return 'en'
    } else if (lang == 'zh') { // 中文
      const language = navigator.language || navigator.userLanguage
      if (language == 'zh-CN' || language == 'zh-cn') {
        return 'zh'
      } else { // 繁体
        return 'fn'
      }
    }
  },
  downloadIamge(imgsrc = '/', name = 'noName') {
    // 下载图片地址和图片名
    const image = new Image()
    // 解决跨域 Canvas 污染问题
    image.setAttribute('crossOrigin', 'anonymous')
    image.onload = function() {
      const canvas = document.createElement('canvas')
      canvas.width = image.width
      canvas.height = image.height
      const context = canvas.getContext('2d')
      context.drawImage(image, 0, 0, image.width, image.height)
      const url = canvas.toDataURL('image/png') // 得到图片的base64编码数据
      const a = document.createElement('a') // 生成一个a元素
      const event = new MouseEvent('click') // 创建一个单击事件
      a.download = name || 'photo' // 设置图片名称
      a.href = url // 将生成的URL设置为a.href属性
      a.dispatchEvent(event) // 触发a的单击事件
    }
    image.src = imgsrc
  },
  formatTime(str = 0) { // 格式时间
    if (!str) { return '' }
    const date = new Date(parseInt(str) * 1000)
    const y = date.getFullYear()
    let m = date.getMonth() + 1
    m = m < 10 ? '0' + m : m
    let d = date.getDate()
    d = d < 10 ? '0' + d : d
    let h = date.getHours()
    h = h < 10 ? '0' + h : h
    let minute = date.getMinutes()
    // let second = date.getSeconds()
    minute = minute < 10 ? '0' + minute : minute
    // second = second < 10 ? '0' + second : second
    // return `${y}.${m}.${d} ${h}:${minute}:${second}`
    return `${y}.${m}.${d} ${h}:${minute}`
  }
}
export function envAsync(time = 100) { // 获取版本信息,异步
  return new Promise((resolve) => {
    setTimeout(() => {
      Cookies.get('env') ? resolve(JSON.parse(Cookies.get('env'))) : resolve({})
    }, time)
  })
  // return Cookies.get('env')
}
